import { Suspense, useEffect } from 'react';
import { lazyWithDelay } from './utils/lazyWithDelay';
const Router = lazyWithDelay(() => import('./config/router'));
import { BrowserRouter } from 'react-router-dom';
import { Toaster } from 'sonner';
import Cookies from 'js-cookie';
import { useAuthStore } from './features/Auth';
import LoadingPage from './features/CNP/pages/LoadingPage';
import { useScreenSize } from './hooks/useScreenSize';
import { observer } from 'mobx-react-lite';
import { setupAuthInterceptor } from './utils/AuthInterceptor';
import { useOnboardStore } from './features/OnBoard/hooks/useOnboardStore';
import { useCompanyStore } from './features/Company';
import { themeStore } from './stores';
import './styles/globals.css';

const App = observer(() => {
	useScreenSize();
	const { getMe, setIsLoading } = useAuthStore();
	const { getCompany } = useOnboardStore();
	const { selectedCompanyId } = useCompanyStore();

	const token = Cookies.get('token');

	setupAuthInterceptor();
	useEffect(() => {
		if (token) {
			getMe().then((success) => {
				if (success) setIsLoading(false);
			});
		} else {
			setIsLoading(false);
		}
	}, [getMe, token]);

	useEffect(() => {
		if (token) {
			if (selectedCompanyId) {
				getCompany();
			}
		}
	}, [selectedCompanyId]);

	return (
		<>
			<BrowserRouter>
				<div className="flex flex-col h-screen">
					<Suspense fallback={<LoadingPage />}>
						<Router />
					</Suspense>
				</div>
			</BrowserRouter>
			<Toaster
				position="top-right"
				duration={3000}
				richColors
				theme={themeStore.theme}
				toastOptions={{
					style: {
						whiteSpace: 'pre-line',
					},
				}}
			/>
		</>
	);
});

export default App;
